module.exports = __webpack_public_path__ + "img/compliance.198e157c.svg";